import { Button, Tooltip } from "@material-ui/core";
import { AttachFile, AttachMoney } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTickets } from "../../Utils/ApiCalls";
import {
  ECABIN,
  formatTimeWithTZOffset,
  TICKET_PRIORITIES,
} from "../../Utils/Common";
import SortableTable from "../SortableTable";
import TicketEntry from "../TicketEntry";

/**
 *
 * @param {JSON} parent e.g. { DeviceId: id }
 * @param {Array<JSON>} [{ id: string, hideFromCsv: boolean, width: number, disablePadding: boolean, label: string }]
 * @returns
 */
export default function TicketList({ parent, headCells, Device }) {
  const { t } = useTranslation();
  const [showTicketEntry, setShowTicketEntry] = useState(false);
  const [refreshList, setRefreshList] = useState("dsfsdfds");
  const [tickets, setTickets] = useState();
  const [selectedTicket, setSelectedTicket] = useState();

  let handleRowClick = (data) => {
    if (data) {
      setSelectedTicket(data);
      setShowTicketEntry(true);
      // setShowTicketEntry(false);
      // setTimeout(() => {
      //   setShowTicketEntry(true);
      // }, 1);
    }
  };

  const handleScrollClick = (event, id) => {};

  useEffect(() => {
    setTickets();
    getTickets(parent, (result) => {
      setTickets(result.tickets);
    });
  }, [parent, refreshList]);

  useEffect(() => {
    return () => {
      setSelectedTicket();
    };
  }, []);

  // useEffect(() => {
  //   if (showTicketEntry === false) {
  //     setRefreshList(Date.now());
  //   }
  // }, [setRefreshList, showTicketEntry]);

  return (
    <>
      <Button
        variant="outlined"
        onClick={() => {
          setSelectedTicket();
          setShowTicketEntry(false);
          setTimeout(() => {
            setShowTicketEntry(true);
          }, 1);
        }}
      >
        {t("newTicket")} +
      </Button>
      <TicketEntry
        device_id={parent?.deviceid || parent?.DeviceId}
        Device={Device}
        showTicketEntry={showTicketEntry}
        setShowTicketEntry={setShowTicketEntry}
        selectedTicket={selectedTicket}
        setSelectedTicket={setSelectedTicket}
        setRefreshList={setRefreshList}
        showHeader={true}
      />
      {tickets ? (
        <SortableTable
          headCells={
            headCells || [
              {
                id: "attachments",
                hideFromCsv: true,
                width: 32,
                label: "",
              },
              {
                id: "expenses",
                hideFromCsv: true,
                width: 32,
                label: "",
              },
              {
                id: "priority",
                numeric: false,
                disablePadding: false,
                label: "Priority",
              },
              {
                id: "description",
                numeric: false,
                disablePadding: false,
                label: t("ticketList.description"),
              },
              {
                id: "action",
                numeric: false,
                disablePadding: false,
                label: t("ticketList.action"),
              },
              {
                id: "details",
                numeric: false,
                disablePadding: false,
                label: t("ticketList.details"),
              },
              {
                id: "state",
                numeric: false,
                disablePadding: false,
                label: t("ticketList.state"),
              },
              {
                id: "User.fullName",
                numeric: false,
                disablePadding: false,
                label: t("ticketList.editor"),
              },
              {
                id: "createdAt",
                numeric: false,
                disablePadding: false,
                label: t("createdAt"),
              },
              {
                id: "updatedAt",
                numeric: false,
                disablePadding: false,
                label: t("updatedAt"),
              },
            ]
          }
          maxDataLength={30}
          tableLayout={"fixed"}
          getRowStyle={(data) => {
            var obj = { cursor: "pointer" };
            if (data.state === "new") {
              return { ...obj, backgroundColor: "lightcoral" };
            }
            if (data.state === "resolved") {
              return { ...obj, backgroundColor: "lightgreen" };
            }
            if (data.state === "progress") {
              return { ...obj, backgroundColor: "lightblue" };
            }
            return obj;
          }}
          defaultSortRow={"updatedAt"}
          handleRowClick={handleRowClick}
          handleScrollClick={handleScrollClick}
          tableData={tickets}
          rowsPerPage={200}
          specialDataFormatting={[
            {
              id: "attachments",
              format: (data) => {
                return data ? (
                  <Tooltip title={"This ticket has attached media"}>
                    <AttachFile color="primary" style={{ fontSize: 20 }} />
                  </Tooltip>
                ) : (
                  ""
                );
              },
            },
            {
              id: "expenses",
              format: (data) => {
                return data ? (
                  <Tooltip title={"This ticket has expenses"}>
                    <AttachMoney color="primary" style={{ fontSize: 20 }} />
                  </Tooltip>
                ) : (
                  ""
                );
              },
            },
            {
              id: "state",
              format: (data) => {
                return t("ticketList." + data);
              },
            },
            {
              id: "priority",
              format: (data) => {
                return Object.keys(TICKET_PRIORITIES).find(
                  (f) => TICKET_PRIORITIES[f] === data
                );
              },
            },
            {
              id: "createdAt",
              format: (data) => {
                return formatTimeWithTZOffset(data, ECABIN);
              },
            },
            {
              id: "updatedAt",
              format: (data) => {
                return formatTimeWithTZOffset(data, ECABIN);
              },
            },
          ]}
        />
      ) : undefined}
    </>
  );
}
